import { Globe } from "lucide-react";
import { useLang, LANGS } from "@/lib/i18n";

export default function LanguageSwitcher({ testid = "lang-switcher" }) {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid={testid}
      role="group"
      aria-label="Select language / Seleccionar idioma / Selecionar idioma"
      title="Language / Idioma"
      className="inline-flex items-center gap-1.5 rounded-full border border-border bg-secondary/50 pl-2.5 pr-0.5 py-0.5"
    >
      <Globe className="h-3.5 w-3.5 text-primary" aria-hidden />
      <div className="flex items-center">
        {LANGS.map((l) => (
          <button
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`lang-${l.code}`}
            aria-pressed={lang === l.code}
            title={l.name}
            aria-label={l.name}
            className={`px-2.5 py-1 rounded-full text-xs font-mono-x font-semibold tracking-wide transition-colors duration-300 ${
              lang === l.code
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {l.label}
          </button>
        ))}
      </div>
    </div>
  );
}
